import React from 'react';
import fieldService from '../../../services/field-service';

class ConditionFieldSelector extends React.Component {

  constructor(props) {
    super(props);
    const selectableFields = props.fields
      .filter(f => !fieldService.isStaticFieldType(f.fieldType))
      .reduce(
        (result, field) => {
          if (field.fieldType !== 'RADIO') {
            result.push(field);
          } else {
            if (!result.find(f => f.fieldType === 'RADIO' && f.label === field.groupName)) {
              // Create a 'fake' field that represents the radio group
              result.push({
                id: field.id, fieldType: field.fieldType, label: field.groupName,
              });
            }
          }
          return result;
        },
        []
      );
    const model = props.model || {};
    if (model.value == null && selectableFields.length > 0) {
      model.type = 'field';
      model.value = selectableFields[0].id;
      props.onChange(model);
    }
    this.state = {
      model: model,
      nonStaticFields: selectableFields,
    };
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = {...prevState.model};
        model[fieldName] = value;
        return {model: model};
      },
      () => this.props.onChange(this.state.model)
    );
  }

  fieldDisabled(field) {
    return field.fieldType === 'DROPDOWN' &&
      field.dataSource === 'CUSTOM_LIST' &&
      (field.possibleValues || []).length === 0;
  }

  render() {
    if (this.state.nonStaticFields.length === 0) {
      return <div className="alert alert-danger text-center" role="alert">
        Please create at least one field
      </div>
    }
    return <select className="form-select"
                   value={this.state.model.value || ''}
                   onChange={e => this.updateModel('value', e.target.value)}>
      {this.state.nonStaticFields.map(f => <option key={f.id} value={f.id} disabled={this.fieldDisabled(f)}>
        {fieldService.fieldDescription(f)}
      </option>)}
    </select>;
  }

}
export default ConditionFieldSelector;